exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".IA_list_17y9CrQZJp8K4ajm9BH7Pb {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  box-sizing: border-box;\n  background-position: center;\n  background-size: cover;\n}\n\n.IA_headline_3PoUa7k7nECHsAe0JeVG3T {\n  width: 100%;\n  text-align: center;\n}", ""]);

// Exports
exports.locals = {
	"IA_list": "IA_list_17y9CrQZJp8K4ajm9BH7Pb",
	"IA_headline": "IA_headline_3PoUa7k7nECHsAe0JeVG3T"
};